import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.string.pad-start";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { addAnnounce, updAnnounce } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewCom } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewCom],
  props: {
    propsData: Object
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      paramsData: {
        id: "",
        language: "",
        context: "",
        start_time: "",
        end_time: "",
        is_timing: "",
        timing: "",
        server_id: ""
      },
      paramsDataMark: {},
      rules: {
        language: [{
          required: true,
          message: this.$t('pleaseSelectLanguage'),
          trigger: "blur"
        }],
        context: [{
          required: true,
          message: this.$t('pleaseInputContent'),
          trigger: "blur"
        }],
        start_time: [{
          required: true,
          message: this.$t('pleaseSelectTime'),
          trigger: "blur"
        }],
        is_timing: [{
          required: true,
          message: this.$t('pleaseSelectScheduledStatus'),
          trigger: "blur"
        }],
        timing: [{
          required: true,
          message: this.$t('pleaseSelectScheduledTime'),
          trigger: "blur"
        }]
      },
      timingList: [{
        label: this.$t('open'),
        value: 1
      }, {
        label: this.$t('close'),
        value: 2
      }],
      formLabelWidth: "80px",
      expires: [],
      nowD: 0
    };
  },
  created: function created() {
    this.paramsDataMark = JSON.parse(JSON.stringify(this.paramsData));
  },
  methods: {
    proving: function proving(e) {
      var val = e;

      if (val.indexOf(".") != -1) {
        val = val.substr(0, 3);
      }

      this.paramsData.sharing_percent = val;
    },
    init: function init(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var now, year, month, day, hours, minutes, seconds, data, k;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;
                now = new Date(_this.$times.zeroTimeZone());
                year = now.getFullYear();
                month = String(now.getMonth() + 1).padStart(2, '0');
                day = String(now.getDate()).padStart(2, '0');
                hours = String(now.getHours()).padStart(2, '0');
                minutes = String(now.getMinutes()).padStart(2, '0');
                seconds = String(now.getSeconds()).padStart(2, '0');
                _this.nowD = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
                _this.paramsData.timing = _this.nowD;

                if (row) {
                  data = JSON.parse(JSON.stringify(row));
                  data.start_time = data.start_time;
                  data.end_time = data.end_time;
                  _this.expires = [data.start_time, data.end_time];

                  for (k in _this.paramsDataMark) {
                    _this.paramsData[k] = data[k];
                  }

                  _this.paramsData.timing = _this.paramsData.timing ? _this.paramsData.timing : "";
                } else {
                  _this.expires = [_this.nowD, _this.nowD];
                  _this.paramsData.start_time = _this.nowD;
                  _this.paramsData.end_time = _this.nowD;
                }

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchTimeChange: function searchTimeChange(e) {
      this.paramsData.start_time = e[0];
      this.paramsData.end_time = e[1];
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.paramsData.id = "";
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var d = JSON.parse(JSON.stringify(_this2.paramsData));
          d.start_time = d.start_time;
          d.end_time = d.end_time;
          d.timing = d.timing ? d.timing : 0;
          var req = d.id ? updAnnounce : addAnnounce;

          if (d.id) {
            _this2.propsData.server_id = _this2.paramsData.server_id;
          } else {
            _this2.propsData.server_id = Array.isArray(_this2.propsData.server_id) ? _this2.propsData.server_id.join(",") : _this2.propsData.server_id;
          }

          req(_objectSpread(_objectSpread(_objectSpread({}, d), _this2.propsData), {}, {
            game_id: _this2.rawData.game_id
          })).then(function (res) {
            if (res.code == 200) {
              Message.success(_this2.$t('operationSuccess'));

              _this2.$emit("refreshDataList");

              _this2.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.paramsData = {
        id: this.paramsData.id,
        language: "",
        context: "",
        end_time: this.nowD,
        start_time: this.nowD,
        is_timing: "",
        timing: ""
      };
      this.expires = [this.nowD, this.nowD];
      this.$refs.ruleForm.resetFields();
    }
  }
};